import React, { useEffect, useState } from "react";
import Header from "../components/Header/Header";
import MobileNavbar from "../components/Header/Mobile/MobileNavbar";
import MobileHeader from "../components/Header/Mobile/MobileHeader";
import ScrollTop from "../components/shared/ScrollTop";
import StoryItem from "../components/HR/StoryItem";
import Footer from "../components/Footer/Footer";
import Stories from "react-insta-stories";
import hrPic from "../images/hr4bnr-per.jpg";
import hrBg from "../images/hr-dark.svg";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { getWindowSize, storiesItem } from "../helper/helper";
import { storiesData } from "../components/HR/StoriesData";

const HRPage = () => {
  const [selectedStory, setSelectedStory] = useState({});
  const [openModal, setOpenModal] = useState(false);
  const [imageLoading, setImageLoading] = useState(false);
  const [svgLoading, setSvgLoading] = useState(false);
  const [windowSize, setWindowSize] = useState(getWindowSize());
  const [stories, setStories] = useState(storiesItem(storiesData));

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    const handleWindowResize = () => {
      setWindowSize(getWindowSize());
    };

    window.addEventListener("resize", handleWindowResize);
  }, []);

  let storyPerview;
  if (windowSize.innerWidth < 720) {
    storyPerview = 3;
  } else if (windowSize.innerWidth < 885) {
    storyPerview = 6;
  } else if (windowSize.innerWidth >= 640 && windowSize.innerWidth <= 1230) {
    storyPerview = 8;
  } else {
    storyPerview = 10;
  }

  return (
    <div className="flex flex-col items-center justify-center mx-auto">
      <Header />
      <MobileNavbar />
      <MobileHeader />
      <ScrollTop />

      {/* story modal */}
      <div
        onClick={() => setOpenModal(false)}
        className={`bg-black ${
          openModal ? "opacity-40 visible" : "opacity-0 invisible"
        } fixed bottom-0 top-0 left-0 right-0 z-[9999] transition-all duration-300`}
      ></div>

      <div
        className={`insta-story-wrapper ${
          openModal
            ? "opacity-100 visible scale-100"
            : "opacity-0 invisible scale-75"
        } transition-all duration-300 rounded-xl overflow-hidden fixed top-2/4 left-2/4 -translate-x-2/4 -translate-y-2/4 z-[99999]`}
      >
        {openModal && (
          <Stories
            stories={stories}
            defaultInterval={1500}
            // width={432}
            // height={768}
            currentIndex={selectedStory.index}
          />
        )}
      </div>

      <div className="w-full xl:max-w-[1300px] flex flex-col items-center lg:mt-24 mt-10 lg:gap-36 gap-20 px-3 2xl:px-0">
        {/* pic & description */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-20">
          <div className="relative">
            <img
              src={hrBg}
              className={`hr-bg absolute -z-10 -top-[10%] lg:-left-[15px] ${
                !imageLoading && "hidden"
              }`}
              alt="پرورش مشاور و مربی"
              onLoad={() => setSvgLoading(true)}
            />
            <img
              src={hrPic}
              className={`hr-image ${
                !imageLoading && "hidden"
              } max-w-[95%] lg:max-w-full`}
              onLoad={() => setImageLoading(true)}
              alt="پرورش مشاور و مربی"
            />
          </div>
          <div className="flex flex-col gap-4">
            <h1 className="text-gray-200 text-2xl lg:text-[40px] leading-[50px] font-black">
              دوره پرورش مربی آزمون های خود ارزیابی و منابع انسانی HR Human
              Resource management
            </h1>
            <p className="text-gray-300 leading-8">
              ۲۷ جلسه ، ۶۰ ساعت مرور دوره : محتوای تصویری و صوتی ضبط شده پرسش و
              پاسخ و تمرین و عضویت در کانال تلگرامی دوره پشتیبانی مستقیم توسط
              پشتیبان دوره و برگذارکننده دوره امکان حضور در کمپ پایان دوره امکان
              دریافت گواهینامه حضور در دوره در صورت قبولی در آزمون امکان انجام
              مشاوره در یونی بست پس از دریافت گواهینامه تعداد آزمون های خود
              ارزیابی : 4 از 4 ( دیسک ، ام بی تی آی ، هالند ، نئو ) ( DISC ,
              MBTI , OCEAN , RIASEC ) دسته بندی آموزش بین المللی : غیر فعال (
              توسعه فردی ، مدیریت کسب و کار ، تخصصی مشاغل ) بررسی نتایج تست ها
              توسط مشاور : فعال هدایت و حمایت توسط پشتیبان : فعال امکان ارتقا
              بسته : دارد توسعه : 5 امتیاز بسته : 2
            </p>

            <Link
              to={"/shop/پرورش-مربی"}
              className="rounded-xl hover:scale-110 transition-all duration-300 w-fit self-center py-3 px-10 bg-gradient-to-tl from-yellow-900 to-yellow-500 text-white"
            >
              خرید دوره
            </Link>
          </div>
        </div>

        <div className="flex flex-col lg:gap-8 gap-5 justify-center items-center">
          <div className="w-fit flex gap-2 text-2xl mt-3 md:text-[40px] font-black items-center pr-[50px] relative">
            <span className="text-gray-200">معرفی</span>{" "}
            <span className="text-yellow-700">دوره</span>
            <div className="dottedSquare"></div>
          </div>

          <video
            src={"https://myunibest.com/videos/hr-2024-promo.mp4"}
            poster={hrPic}
            className="max-w-[800px] w-full rounded-xl"
            controls
          ></video>

          <div className="max-w-[800px] w-full flex flex-col lg:gap-6 gap-4">
            <div className="flex flex-col gap-4">
              <div className="w-fit flex gap-2 text-2xl mt-3 md:text-4xl font-black items-center pr-[50px] relative">
                <span className="text-gray-200">عنوان</span>{" "}
                <span className="text-yellow-700">دوره</span>
                <div className="dottedSquare"></div>
              </div>

              <p className="text-gray-300 leading-7 text-sm md:text-base">
                برگذار کننده : دکتر محمد خدادادی شرکت در دوره : آنلاین ( میت )
                مدت زمان دوره : ۲۷ جلسه ، ۶۰ ساعت مرور دوره : محتوای تصویری و
                صوتی ضبط شده پرسش و پاسخ و تمرین و عضویت در کانال تلگرامی دوره
                پشتیبانی مستقیم توسط پشتیبان دوره و برگذار کننده دوره امکان حضور
                در کمپ پایان دوره امکان دریافت گواهینامه حضور در دوره در صورت
                قبولی در آزمون امکان انجام مشاوره در یونی بست پس از دریافت
                گواهینامه تعداد آزمون های خود ارزیابی : 4 از 4 ( دیسک ، ام بی تی
                آی ، هالند ، نئو ) ( DISC , MBTI , OCEAN , RIASEC ) دسته بندی
                آموزش بین المللی : غیر فعال ( توسعه فردی ، مدیریت کسب و کار ،
                تخصصی مشاغل ) بررسی نتایج تست ها توسط مشاور : فعال هدایت و حمایت
                توسط پشتیبان : فعال امکان ارتقا بسته : دارد توسعه : 5 امتیاز
                بسته : 2
              </p>
            </div>
          </div>

          <div className="max-w-[800px] w-full flex flex-col lg:gap-6 gap-4">
            <div className="flex flex-col gap-4">
              <div className="w-fit flex gap-2 text-2xl mt-3 md:text-4xl font-black items-center pr-[50px] relative">
                <span className="text-gray-200">برگذار</span>{" "}
                <span className="text-yellow-700">کننده</span>
                <div className="dottedSquare"></div>
              </div>

              <p className="text-gray-300 leading-7 text-sm md:text-base">
                استاد محمد خدادادی دکتری مدیریت کسب و کار دانشگاه تهران ، مدیریت
                ارشد کسب و کار دانشکده کسب و کار grenoble فرانسه مدرس مهارت های
                نرم دارای مدارک آکادمیک و غیر آکادمیک ، در زمینه مدیریت ، کسب و
                کار ، روانشناسی ، اقتصاد ، فروش و بازاریابی ، فن بیان و سخنوری ،
                خودشناسی و جامعه شناسی برگرفته از اساتید بزرگ بین المللی و داخلی
                . بنیانگذار باشگاه کارآفرینان اوربست ؛ اکو سیستم یونی بست
                (استعداد یابی و مهارت آموزی بین المللی) رییس هییت مدیره شرکت تمل
                مشاور شغلی واقتصادی، با تجربه ای موفق در چند ده شغل تولیدی ،
                خدماتی و اجتماعی ، کارآفرین ، برگذارکننده صدها سمینار موفقیت ،
                خودارزیابی و کارآفرینی در سرتاسر ایران
              </p>
            </div>
          </div>

          <div className="max-w-[800px] w-full flex flex-col lg:gap-6 gap-4">
            <div className="flex flex-col gap-4">
              <div className="w-fit flex gap-2 text-2xl mt-3 md:text-4xl font-black items-center pr-[50px] relative">
                <span className="text-gray-200">اهداف</span>{" "}
                <span className="text-yellow-700">دوره</span>
                <div className="dottedSquare"></div>
              </div>

              <p className="text-gray-300 leading-7 text-sm md:text-base">
                مربی مي بايست بعد از اين دوره مدل های رفتاري و شخصیتی خويش را
                شناخته و توضيح دهد . مربی مي بايست بعد از اين دوره مدل های
                رفتاري و شخصیتی اطرافیان را شناخته و توضيح دهد. مربی مي بايست
                بعد از اين دوره بتواند مدل رفتاري و شخصیتی خود را با ديگران
                تطبيق دهد. مربی مي بايست بعد از اين دوره، ارتباط موثر با دیگران
                برقرار نمايد. مربی مي بايست بعد از اين دوره ، نکات تقویت و تعدیل
                خود را دانسته و مهارت های لازم را در این خصوص کسب نماید . مربی
                می بایست بعد از این دوره علت تضادهای بین فردی را بداند. مربی می
                بایست بعد از این دوره چهار تست یونی بست را براساس نمودار در خصوص
                هر فرد تحلیل نماید . مربی می بایست بعد از این دوره مشاغل مناسب
                هر فرد را براساس تحلیل تست ها مشخص نماید . مربی می بایست بعد از
                این دوره چالش های رفتاری و شخصیتی فرد در هر محیطی را پیش بینی
                نماید . مربی می بایست بعد از این دوره نسخه آموزشی مناسب در
                راستای پیشبرد شرایط کاری و شخصی برای هر فرد را تجویز نماید .
                مربی می بایست بعد از این دوره بتواند رشته تحصیلی و دانشگاهی
                مناسب برای هر فرد را مشخص نماید .
              </p>
            </div>
          </div>
        </div>

        {/* stories */}
        <div className="w-full flex flex-col items-center gap-8">
          <div className="w-fit flex gap-2 text-2xl mt-3 md:text-[40px] font-black items-center pr-[50px] relative">
            <span className="text-gray-200">نظرات</span>{" "}
            <span className="text-yellow-700">دوره</span>
            <div className="dottedSquare"></div>
          </div>

          <div className="w-full flex flex-wrap gap-4">
            <Swiper
              className="mySwiper lg:col-span-6 header-slider"
              pagination={{
                dynamicBullets: true,
              }}
              slidesPerView={storyPerview}
            >
              {stories.map((story, i) => (
                <SwiperSlide className="">
                  <StoryItem
                    index={i}
                    data={story}
                    openModal={openModal}
                    setOpenModal={setOpenModal}
                    setSelectedStory={setSelectedStory}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default HRPage;
